import type { IssuePriority, IssueStatus } from '../shared/schema.ts';

export const STATUS_LABELS: Record<IssueStatus, string> = {
  backlog: 'Backlog', todo: 'Todo', 'in-progress': 'In progress', review: 'Review', done: 'Done',
};
export const PRIORITY_LABELS: Record<IssuePriority, string> = { urgent: 'Urgent', high: 'High', medium: 'Medium', low: 'Low' };

const MINUTE = 60_000, HOUR = 60 * MINUTE, DAY = 24 * HOUR;
/** "just now", "4m", "3h", "2d", then a date. Short, because it sits in a mono column. */
export function ago(ms: number, now = Date.now()): string {
  const d = now - ms;
  if (d < MINUTE) return 'just now';
  if (d < HOUR) return `${Math.floor(d / MINUTE)}m ago`;
  if (d < DAY) return `${Math.floor(d / HOUR)}h ago`;
  if (d < 30 * DAY) return `${Math.floor(d / DAY)}d ago`;
  return new Date(ms).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

/** A short, stable label for an issue: seeded ones are numbered, ones visitors made are not. */
export function issueKey(id: string): string {
  const seeded = /^seed-0*(\d+)$/.exec(id);
  return seeded ? `R-${seeded[1]}` : `R-${id.replace(/^u-/, '').slice(0, 4).toUpperCase()}`;
}
